import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppBuflowMapComponent } from './app-buyflow-map.component';
import { SwiperCarouselModule } from '../public-components/swiper-carousel/swiper-carousel.module';
import { SwiperModule } from 'ngx-swiper-wrapper';
import { FlexLayoutModule } from '@angular/flex-layout';
import { CarouselVesselCardModule } from '../public-components/carousel-vessel-card/carousel-vessel-card.module';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatFormFieldModule } from '@angular/material/form-field';
import { GoogleMapsModule } from '@angular/google-maps';

@NgModule({
  declarations: [AppBuflowMapComponent],
  imports: [
    CommonModule,
    GoogleMapsModule,
    SwiperCarouselModule,
    SwiperModule,
    FlexLayoutModule,
    CarouselVesselCardModule,
    MatFormFieldModule,
    MatIconModule,
    MatProgressSpinnerModule,
    GoogleMapsModule,
  ],
  exports: [AppBuflowMapComponent],
})
export class AppBuflowMapModule {}
